"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIGMA_MODEL_ENTRY_FORM_LATEST = exports.SigmaModelEntryFormDataSchema = void 0;
exports.upgradeSigmaModelEntryFormData = upgradeSigmaModelEntryFormData;
exports.parseSigmaModelEntryFormDataToLatest = parseSigmaModelEntryFormDataToLatest;
const z = require("zod");
const form_latest_1 = require("./form-latest");
const form_v1_1 = require("./form-v1");
__exportStar(require("./form-latest"), exports);
__exportStar(require("./form-v1"), exports);
exports.SigmaModelEntryFormDataSchema = z.discriminatedUnion('formVersion', [
    form_v1_1.SigmaModelEntryFormStateV1Schema,
    form_latest_1.SigmaModelEntryFormStateSchema,
]);
function upgradeSigmaModelEntryFormData(formData) {
    return formData.formVersion === form_v1_1.SIGMA_MODEL_ENTRY_FORM_V1_VERSION ?
        (0, form_v1_1.migrateSigmaModelEntryFormV1ToLatest)(formData)
        : formData;
}
function parseSigmaModelEntryFormDataToLatest(rawFormData) {
    const parsed = exports.SigmaModelEntryFormDataSchema.safeParse(rawFormData);
    return parsed.success ? upgradeSigmaModelEntryFormData(parsed.data) : null;
}
exports.SIGMA_MODEL_ENTRY_FORM_LATEST = form_latest_1.sigmaModelEntryFormLatest;
//# sourceMappingURL=index.js.map